import React from "react";
import PropTypes from "prop-types";
import R from "ramda";
import styles from "components/documents/dropdown.scss";
import FaBars from "react-icons/fa/bars";
import FaLeftChevron from "react-icons/fa/angle-left";
import FaRightChevron from "react-icons/lib/fa/angle-right";
import { documentPropType } from "custom-prop-types";
import { DropdownModal } from "components/common/dropdown-modal";
import { Button, ToggleButton } from "components/common/button";

export const DropdownActionsPanel = ({
  accountId,
  documents,
  focusedDocument,
  isDocViewerHamburgerMode,
  onEndDocViewerHamburgerMode,
  onFocusDocument,
  onDocumentViewed,
  onReprocessDocument,
  onShowChangeDocType,
  onShowShareUrl,
  onShowTrashDocument,
  onStartDocViewerHamburgerMode,
  onUnfocusDocument,
  rowHeight
}) => {
  const focusedDocumentIndex = R.findIndex(R.propEq("id", focusedDocument.id), documents);
  const cleanDocuments = (
    documents.map(document => R.merge(document, { downloadUrl: R.path(["attachment", "url"], document) }))
  );
  const newStyle = (offset) => R.set(R.lensProp("top"), focusedDocument.style.top + offset, focusedDocument.style);
  return (
    <div className={ styles.toolbar }>
      <Button
        disabled={ focusedDocumentIndex === 0 }
        onClick={ () => {
          onUnfocusDocument();
          onFocusDocument(cleanDocuments[focusedDocumentIndex - 1], newStyle(rowHeight * -1));
          onDocumentViewed({ accountId, document: cleanDocuments[focusedDocumentIndex - 1] });
        } }
      >
        <FaLeftChevron size={ 15 } />
      </Button>
      <ToggleButton
        isOpen={ isDocViewerHamburgerMode }
        onCloseClick={ onEndDocViewerHamburgerMode }
        onOpenClick={ onStartDocViewerHamburgerMode }
      >
        <FaBars size={ 15 } />
      </ToggleButton>
      <DropdownModal
        offsetLeft={ -40 }
        offsetTop={ 20 }
        onClose={ onEndDocViewerHamburgerMode }
        visible={ isDocViewerHamburgerMode }
        width={ 200 }
      >
        <div className={ styles["dropdown-buttons"] }>
          <Button link onClick={ () => { onReprocessDocument(accountId); } }>Reprocess Document</Button>
          <Button link onClick={ onShowChangeDocType }>Change Document Type</Button>
          <Button link onClick={ onShowShareUrl }>Share Document</Button>
          <Button link onClick={ () => { window.open(cleanDocuments[focusedDocumentIndex].downloadUrl); } }>
            Download document
          </Button>
          <Button danger link onClick={ onShowTrashDocument }>Trash</Button>
        </div>
      </DropdownModal>
      <div className={ styles["right-arrow"] }>
        <Button
          disabled={ focusedDocumentIndex === cleanDocuments.length - 1 }
          onClick={ () => {
            onUnfocusDocument();
            onFocusDocument(cleanDocuments[focusedDocumentIndex + 1], newStyle(rowHeight));
            onDocumentViewed({ accountId, document: cleanDocuments[focusedDocumentIndex + 1] });
          } }
        >
          <FaRightChevron size={ 15 } />
        </Button>
      </div>
    </div>
  );
};

DropdownActionsPanel.defaultProps = {
  focusedDocument: null
};

DropdownActionsPanel.propTypes = {
  accountId: PropTypes.string.isRequired,
  documents: PropTypes.arrayOf(documentPropType).isRequired,
  focusedDocument: documentPropType,
  isDocViewerHamburgerMode: PropTypes.bool.isRequired,
  onDocumentViewed: PropTypes.func.isRequired,
  onEndDocViewerHamburgerMode: PropTypes.func.isRequired,
  onFocusDocument: PropTypes.func.isRequired,
  onReprocessDocument: PropTypes.func.isRequired,
  onShowChangeDocType: PropTypes.func.isRequired,
  onShowShareUrl: PropTypes.func.isRequired,
  onShowTrashDocument: PropTypes.func.isRequired,
  onStartDocViewerHamburgerMode: PropTypes.func.isRequired,
  onUnfocusDocument: PropTypes.func.isRequired,
  rowHeight: PropTypes.number.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/documents/documents-grid/dropdown-actions-panel.jsx